import './AdTargetingMeter.sass';

import { FC, useMemo } from 'react';

import { useTranslator } from '$hooks';
import gaugeImg from '$assets/gauge/gauge.png';
import { ReactComponent as IcArrow } from '$assets/gauge/arrow.svg';
import { AdTargetingMeterProps } from './AdTargetingMeter.interface';
import { classNames, formatBigNumber } from '$utils';
import { Loader } from '$shared/components';

export const AdTargetingMeter: FC<AdTargetingMeterProps> = ({
  value,
  max,
  min,
  isLoading,
}) => {
  const t = useTranslator();

  const data = useMemo(() => {
    const percent = Math.max(0, Math.min(100, ((value - min) / max) * 100));

    let title = '';
    let caption = '';
    let arrowColor: 'red' | 'orange' | 'green';
    if (percent < 33) {
      title = t('ad_targeting_meter_poor_title');
      caption = t('ad_targeting_meter_poor_caption');
      arrowColor = 'red';
    } else if (percent < 66) {
      title = t('ad_targeting_meter_good_title');
      caption = t('ad_targeting_meter_good_caption');
      arrowColor = 'orange';
    } else {
      title = t('ad_targeting_meter_maximised_title');
      caption = t('ad_targeting_meter_maximised_caption');
      arrowColor = 'green';
    }

    return {
      percent,
      title,
      caption,
      arrowColor,
    };
  }, [value, max, t, min]);

  return (
    <div
      className={classNames({
        AdTargetingMeter__gauge_wrap: true,
        loading: isLoading,
      })}
    >
      {isLoading && (
        <div className="AdTargetingMeter__loader">
          <Loader />
        </div>
      )}
      <div className="AdTargetingMeter__gauge_content">
        <div className="AdTargetingMeter__gauge">
          <img src={gaugeImg} />
          <span className="AdTargetingMeter__gauge_minValue">{formatBigNumber(min)}</span>
          <div
            className={`AdTargetingMeter__gauge_arrow ${data.arrowColor}`}
            style={{
              rotate: `${data.percent * 1.8}deg`,
            }}
          >
            <IcArrow />
          </div>
          <span className="AdTargetingMeter__gauge_maxValue">{formatBigNumber(max)}</span>
        </div>

        <div className="AdTargetingMeter__title">{data.title}</div>
        <div className="AdTargetingMeter__desc">{data.caption}</div>
      </div>
    </div>
  );
};
